/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/*!****************************************************************!*\
  !*** ./resources/scripts/components/le-reviews-filter/main.js ***!
  \****************************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/**
 * le-reviews-filter — show/hide review tiles by data-category.
 */

var initReviewsFilter = function initReviewsFilter(root) {
  var filterRoot = root.querySelector("[data-le-reviews-filter]");
  if (!filterRoot) return;
  var filterBtns = filterRoot.querySelectorAll("[data-category]");
  var tiles = root.querySelectorAll("[data-le-review-tile]");
  filterBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var category = btn.dataset.category;
      filterBtns.forEach(function (b) {
        var active = b === btn;
        b.classList.toggle("le-reviews__filter--active", active);
        b.setAttribute("aria-pressed", active ? "true" : "false");
      });
      tiles.forEach(function (tile) {
        var tileCategory = tile.dataset.category || "";
        var show = category === "all" || tileCategory === category;
        tile.hidden = !show;
      });
    });
  });
};
var leReviewsFilter = function leReviewsFilter() {
  document.querySelectorAll("[data-le-reviews]").forEach(initReviewsFilter);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (leReviewsFilter);
document.addEventListener("DOMContentLoaded", leReviewsFilter);
/******/ })()
;